import { observer } from "mobx-react";
import { currencyMsg } from "../../utils/constants";
import Tooltip from "./Tooltip";
import CurrencyDropdown from "./CurrencyDropdown";

const DropDownWithInfo = observer(
  ({
    isMenuOpen,
    setIsMenuOpen,
    list,
    selectedItem,
    //  setSelectedItem,
    applyFilter,
    popupMenuClass,
  }) => {
    // const SomeList = () => {
    //   const selectOption = (item) => {
    //     // setSelectedItem(item)
    //     setIsMenuOpen(false);
    //     applyFilter(item);
    //   };

    //   return (
    //     <ul className="portfolio_report_accounts_container">
    //       {list.list?.map((listItem) => (
    //         <li
    //           className="account_listitem cursor"
    //           onClick={() => selectOption(listItem)}
    //         >
    //           <div
    //             className="radio_btn_input"
    //             onClick={() => selectOption(listItem)}
    //           >
    //             {listItem[list.keyName] === selectedItem ? (
    //               <FilledButton />
    //             ) : (
    //               <EmptyButton />
    //             )}
    //           </div>
    //           <label
    //             className="radio_btn_label cursor"
    //             for={listItem[list.keyName]}
    //           >
    //             <OverflowingText
    //               text={listItem[list.keyName]}
    //               width={160}
    //               textClassName="radio_btn_label cursor_imp"
    //               tooltipOnHover={true}
    //               position="left"
    //               tooltipClassName="accounts_tooltip_styles"
    //             />
    //           </label>
    //         </li>
    //       ))}
    //     </ul>
    //   );
    // };

    return (
      <div className="dropDown_info">
        {" "}
        {/* <GoldenDropDown
          heading={selectedItem}
          ReportMenuContent={SomeList}
          isDisabled={false}
          showPopup={true}
          reportsMenuOpen={isMenuOpen}
          setReportsMenuOpen={(menuAction) => setIsMenuOpen(menuAction)}
          // position={{ top: "56px", left: "0px" }}
          position={{
            zIndex: "20",
            overflowY: "hidden",
            border: "1px solid #e3e3e3",
          }}
          showArrow={false}
          dropDownContainerClass="all_accounts_dropdown"
          popupMenuClass={popupMenuClass}
        />{" "} */}
        <CurrencyDropdown
          heading={selectedItem}
          headingValue={selectedItem}
          setHeadingValue={(item) => applyFilter(item)}
          position={{
            zIndex: "20",
            overflowY: "hidden",
            border: "1px solid #e3e3e3",
          }}
          showArrow={false}
          showPopup={true}
          // showArrow={true}
          disabledPopup={false}
          isDisabled={false}
          popupClassName={{
            wrapperClass: "popup_menu_container",
            dropDownContainerClass: "all_accounts_dropdown ugl-report",
            popupMenuClass: "",
          }}
          restrictHover={true}
          OPTIONS={list.list}
          list={list}
          accessibilityValues={{
            buttonId: "",
            ariaHaspopup: "radiogroup",
            ariaControls: "currency-options",
            ariaLabel: "Currency Type",
          }}
        />
        <Tooltip msg={currencyMsg} />
      </div>
    );
  },
);

export default DropDownWithInfo;
